import { Row, Col, FormGroup } from "reactstrap"
export default function UserDetails({ user, fetchCustomerData }) {
    const roleName = localStorage.getItem('roleName')
    const userDetails = [
        { label: "First Name", value: user?.profile?.firstName },
        { label: "Last Name", value: user?.profile?.lastName },
        { label: "Phone Number", value: `${user?.userDetails?.dialCode} ${user?.userDetails?.phone}` },
        { label: "Email Address", value: user?.email },
        { label: "User Name", value: user?.userDetails?.userName || '' },
        { label: "User Role", value: user?.role },
    ]
    const customerDetails = [
        { label: "First Name", value: fetchCustomerData?.customerInfo?.firstName },
        { label: "Last Name", value: fetchCustomerData?.customerInfo?.lastName },
        { label: "User Name", value: fetchCustomerData?.customerInfo?.userName },
        { label: "Account Number", value: fetchCustomerData?.customerInfo?.customerId },
        { label: "Phone Number", value: `${fetchCustomerData?.customerInfo?.dialCode}-${fetchCustomerData?.customerInfo?.mobile}` },
        { label: "Email Address", value: fetchCustomerData?.customerInfo?.email },
        { label: "Address 1", value: fetchCustomerData?.customerInfo?.addressLine1 },
        { label: "Address 2", value: fetchCustomerData?.customerInfo?.addressLine2 },
        { label: "Country", value: fetchCustomerData?.customerInfo?.country },
        { label: "State", value: fetchCustomerData?.customerInfo?.state },
        { label: "City", value: fetchCustomerData?.customerInfo?.city },
        { label: "Zipcode", value: fetchCustomerData?.customerInfo?.zipCode },
    ];
    const details = roleName !== "Customer" ? userDetails : customerDetails
    return (<div>
        <Row className="gy-4 py-4">
            <h5 className="rv-page-title border-bottom py-3">Personal Details</h5>
            {details?.map((detail, index) =>
                <Col xs={12} md={6} lg={6} key={index} className='border-bottom'>
                    <FormGroup>
                        <p className="fw-semibold fs-14">{detail.label}</p>
                        <p className='mb-0'>{detail.value ? detail.value : "-"}</p>
                    </FormGroup>
                </Col>
            )}
        </Row>
    </div>)
}